module.exports = __webpack_public_path__ + "img/half_year_bm.fd0fa3ee.jpg";